import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import { formatUrl } from "@utils/formatUrl";

let serverUrl = getSecret('SERVER_AUTH_URL')

export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_GROUPS(state, groups) {
    state.cached = groups
  },
}

export const actions = {
  init({ state, dispatch }) {},

  fetchGroups(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/groups/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_GROUPS', request)
      return request
    })
  },

  fetchGroupsDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateGroups(context, formData) {
    let promise = null
    if (formData.url) {
      promise = axios.put(formatUrl(formData.url), formData)
    } else {
      promise = axios.post(`${serverUrl}/api/groups/`, formData)
    }
    return promise.then((response) => {
      return response.data
    })
  },
  deleteGroups(context, permUrl) {
    let promise = null
    promise = axios.delete(permUrl)
    return promise.then((response) => {
      return response.data
    })
  },
}
